var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterappliedColIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filter_applied",
    "data-name": "Filter applied",
    transform: "translate(-568 -2391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_315_35",
    "data-name": "Component 315 \\u2013 35",
    transform: "translate(568 2392)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1209",
    "data-name": "Rectangle 1209",
    width: 16,
    height: 16,
    fill: "#ffe9e9",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1211",
    "data-name": "Rectangle 1211",
    width: 14,
    height: 14,
    transform: "translate(1 1)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "filter",
    d: "M14.7,3H2L7.081,9.008v4.154l2.541,1.27V9.008Z",
    transform: "translate(-0.351 -0.998)",
    fill: "none",
    stroke: "#70777f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_203",
    "data-name": "Ellipse 203",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(578 2391)",
    fill: "#e00f0f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterappliedColIcon);
export default __webpack_public_path__ + "static/media/filterapplied-col-icon.6e02e354805d7bdbc21d29e5f80a18b3.svg";
export { ForwardRef as ReactComponent };